import { StatTile } from './StatTile';

interface OnCallTileProps {
  hours: number | undefined;
  topProjectName: string | null | undefined;
  loading?: boolean;
}

/**
 * "On-call hours" StatTile — reads from
 * `widgets.myWeek.onCallHoursThisWeek` / `.onCallTopProjectName` (Phase B
 * backend additions). Mirrors the prototype's "ON-CALL HOURS · 8h · This
 * week · MAPPS SOW 2".
 *
 * When the user has zero on-call hours, the tile still renders ("0h ·
 * None this week") so the MyTime stack stays a consistent height — it's
 * an indicator, not a thing-to-do.
 */
export function OnCallTile({
  hours,
  topProjectName,
  loading,
}: OnCallTileProps) {
  const h = hours ?? 0;
  const sub = topProjectName
    ? `This week · ${topProjectName}`
    : h > 0
      ? 'This week'
      : 'None this week';
  return (
    <StatTile
      label="On-call hours"
      value={`${formatHours(h)}h`}
      sub={sub}
      valueColor={h > 0 ? 'primary.main' : 'text.primary'}
      loading={loading}
      data-testid="stat-on-call-hours"
    />
  );
}

function formatHours(n: number): string {
  return Number.isInteger(n) ? String(n) : n.toFixed(1);
}
